export const AUCTIONS = 'auctions'
export const CALLS = 'calls'
export const IMAGES = 'images'
